export default __webpack_public_path__ + "static/media/1pass.5ab4b9e8.png";